module.exports = __webpack_public_path__ + "8f29803f.svg";